import global from "@/assets/js/global";
import tldjs from "tldjs";

const env = process.env.NODE_ENV
const config = (() => {
  const host = tldjs.getDomain(location.host);
	if (env === "production") {
		if (global.environment === "production") {
			return {
				baseUrl: `https://service.${host}/arc-ai-api/api`,
        googleApiKey: 'AIzaSyCEMLyJHVthhqr1qbzZeMKZRRStNvhtg-M'
			}
		} else {
			return {
				baseUrl: `https://staging.${host}/arc-ai-api/api`,
        googleApiKey: 'AIzaSyCEMLyJHVthhqr1qbzZeMKZRRStNvhtg-M'
			}
		}
	} else {
		return {
			baseUrl: "/app",
      googleApiKey: 'AIzaSyD3PF4jRZkzIGXbcNGW7n09nMqDYPMcVYc'
		}
	}
})();

export default config
